// kecoChemApi.js / msdsOpenApi.js 공용 에러 메시지 추출기
export function extractErrorMessage(err, fallback = "정보를 불러오지 못했습니다.") {
  return (err.response && err.response.data && err.response.data.message) || fallback;
}
